import {PhoneNumberUtil} from 'libphonenumber';

const PRIMARY_PHONE_TYPE_MAP = {
    home: 'homeNumber',
    mobile: 'cellNumber',
    work: 'workNumber'
};

class RelatedAccountContacts {
    constructor(InsuranceSuiteMetadata, $filter, ContactService) {
        this._InsuranceSuiteMetadata = InsuranceSuiteMetadata;
        this._translateRole = name => $filter('translate')(`gateway.contacts.common.views.roles.${name}`);
        this._contactsService = ContactService;
        this.selectedRelationship = null;
    }

    $onChanges(changesObj) {
        this.descriptionData = {
            accountNumber: this.accountNumber,
            accountName: this.accountName
        };
        if (changesObj.accountNumber) {
            this.resetQuery();
        }
    }

    getPrimaryPhoneNumber(contact) {
        const phoneNumber = contact[PRIMARY_PHONE_TYPE_MAP[contact.primaryPhoneType]];
        const phoneUtils = PhoneNumberUtil.getInstance();

        if (!phoneNumber) return null;
        try {
            return phoneUtils.format(phoneUtils.parse(phoneNumber, this._defaultLocaleDetails.countryCode));
        } catch (e) {
            return phoneNumber;
        }
    }

    resetQuery() {
        this.loadContacts(0, this.pageSize);
    }

    setRelFilter(value) {
        if (this.selectedRelationship !== value) {
            this.selectedRelationship = value;
            this.resetQuery();
        }
    }

    getRelationshipDescriptionKey() {
        return `${this.relationshipKeysPrefix}.${this.selectedRelationship || '$all'}`;
    }

    loadContacts(toPage, pageSize) {
        if (!this.accountNumber) return;

        const currentPage = toPage;
        this.loaded = false;
        let queryPromise;
        if (this.selectedRelationship !== '$common') {
            const relationshipFilter = this.selectedRelationship ? [this.selectedRelationship] : [];
            queryPromise = this._contactsService.getRelatedAccountContacts(this.accountNumber, relationshipFilter, currentPage, pageSize);
        } else {
            queryPromise = this._contactsService.getCommonAccountContacts(this.accountNumber, currentPage, pageSize);
        }

        queryPromise.then((data) => {
            this.contacts = data.accountContacts;
            this.firstContact = currentPage * pageSize;
            this.currentPage = currentPage;
            this.totalContacts = data.maxNumberOfResults;
            this.loaded = true;
        });
    }
}

RelatedAccountContacts.$inject = ['InsuranceSuiteMetadata', '$filter', 'ContactService'];

export default RelatedAccountContacts;